<template>
  <div class="module-container">
    <div class="row">
      <div class="col-8">
        <select-clients 
          v-on:removeAllClients="removeAllClients" 
          v-on:removeClient="removeClient" 
          v-on:addClient="addClient" 
          v-on:addQueueIntoClients="addQueueIntoClients"
          :wallets="wallets" 
          :groups="groups" 
          :user_queues_chat="user_queues_chat" 
        />   
      </div>

      <div class="col-4">
        <preview-whatsapp :selectedTemplate="selectedTemplatePreview" />
        <start-conversation :marketingTemplate="true" :marketingSelected="!!selectedTemplatePreview"
          @prepareCampaign="processCampaign($event)" clientName="{NomeDoCliente}" :allTemplates="allTemplates"
          :clientsArray="clients" :disabled="!clients.length" />
      </div>
    </div>

    <hr>

    <div class="sub-campaign">
      <input type="text" class="form-control" placeholder="Nome da Campanha" v-model="campaignName">
      <button @click="submitCampaign" class="submit-button"
        :class="{ 'disabled-button': !clients.length || !selectedTemplatePreview }"
        :disabled="!clients.length || !selectedTemplatePreview"
        :title="!clients.length || !selectedTemplatePreview ? 'Selecione um template e pelo menos um contato para enviar' : 'Enviar campanha'">
        Enviar <i class="fas fa-paper-plane"></i>
      </button>
    </div>
  </div>
</template>

<script>
import PreviewWhatsapp from './PreviewWhatsapp.vue';
import SelectClients from './SelectClientes.vue';
import MessageText from './MessageText.vue';
import StartConversation from '../newScreen/mensagem/StartConversation.vue';
import { mapActions } from 'vuex';

export default {
  props: {
    wallets: {
      type: Array,
      default: []
    },
    groups: {
      type: Array,
      default: []
    },
    user_queues_chat: {
      type: Array,
      default: []
    },
  },
  components: {
    PreviewWhatsapp,
    SelectClients,
    MessageText,
    StartConversation
  },
  data() {
    return {
      text: [],
      selectedTemplatePreview: "",
      clients: [],
      controlMsgs: 1,
      campaignName: '',
      allTemplates: [],
      dbTemplates: [],
      campaignPayload: [],
      selectedQueue: null,
    }
  },
  mounted() {
    this.getAllTemplates()
  },
  methods: {
    ...mapActions(["sendCampaign"]),
    addClient(client){
      if (this.selectedQueue) client.queue = this.selectedQueue;

      this.clients.push(client);
    },
    addQueueIntoClients(queue) {
      this.selectedQueue = queue;
      this.clients = this.clients.map(client => ({ ...client, queue }));
    },
    removeClient(client) {
      if (!client) return
      const tempClients = this.clients.filter(el => (el.name != client.name) && (el.phone != client.phone));
      if (tempClients) this.clients = tempClients;
      if (!this.clients) this.clients = [];
    },
    removeAllClients() {
      this.clients = [];
    },
    async submitCampaign() {
      // try {
      //   const { data } = await axios.get("/marketing/campaignsToday");
      //   if ((data.length + this.campaignPayload.length) > 900) {
      //     const limite = (data.length + this.campaignPayload.length) - 900;
      //     return Swal.fire({
      //       type: 'error',
      //       title: 'Limite diário de envios excedido!',
      //       text: `Limite diário de 900 envios por dia excedido!\nPassou ${limite} dos 900 envios.`
      //     });
      //   }
      // } catch (error) {
      //   return console.error(error);
      // }

      if (!this.campaignPayload.length) {
        Swal.fire({
          type: 'error',
          title: 'Nenhum contato selecionado!',
          text: "Selecione pelo menos 1 contato para iniciar a campanha!"
        });
        return;
      }

      const id = Date.now();
      if (!this.campaignName) {
        this.campaignName = `campanha-${id}`;
      }

      this.campaignPayload.forEach(el => {
        if (el.phone.includes('@s.whatsapp.net')) {
          const phoneArr = el.phone.split('@')
          if (phoneArr.length) {
            el.formattedPhone = phoneArr[0]
          } else {
            el.formattedPhone = el.phone
          }
        } else {
          el.formattedPhone = el.phone
        }
        el.id = id;
        el.campaignName = this.campaignName;
      });

      axios.post('/marketing/addCampaign', this.campaignPayload)
        .then(() => {
          this.sendCampaign(this.campaignPayload);
          Swal.fire(
            `Campanha "${this.campaignName}" iniciada.`,
            'Os clientes selecionados receberão as mensagens em breve.',
            'success'
          ).then(() => {
            location.reload();
          });

          this.campaignName = '';
          this.clients = [];
          this.selectedTemplates = [];
          this.text = [];
        });
    },
    processCampaign(data) {
      this.selectedTemplatePreview = data.preview;
      console.log({ data });
      this.campaignPayload = data.campaignPayload;
    },
    async getAllTemplates() {
      const chatQueues = user.getChatQueues()
      const queues_ids = []
      if (chatQueues.length) {
        chatQueues.map(el => queues_ids.push(parseInt(el)))
      }

      await axios.get(`https://api.advancemanagement.com.br:${process.env.MIX_WEBHOOK_PORT}/get_template_list`)
        .then(({ data }) => this.allTemplates = data);
    }
  },
}
</script>

<style scoped lang="scss">
#msg-text-slot {
  max-height: 25vh;
  overflow-y: auto;
}

.col {
  padding-right: 0;
  padding-left: 0;
}

.d-flex {
  margin-top: 40px;
  flex-direction: column;
}

.submit-form-container {
  margin-top: 12px;
}

.submit-button {
  color: #fff;
  background: #25d366;
  width: 180px;
  border: none;
  font-weight: bold;
  border-radius: 10px !important;
}

.submit-button:hover {
  background: #157237;
}

.action-buttons {
  margin: 10px 0px;
  text-align: center;
}

#add-button {
  color: #635994;
  font-weight: bold;
  font-size: 14px;
  background-color: white;
  border-radius: 10px !important;
  border: 3px solid #635994;
  padding-left: 2px;
  padding-right: 2px;
}

#add-button:hover {
  color: white;
  border: 3px solid #635994;
  background-color: #8f81d3b7;
}

#del-button {
  color: #f92f60;
  font-weight: bold;
  font-size: 14px;
  background-color: white;
  border-radius: 10px !important;
  border: 3px solid #f92f60;
  padding-left: 2px;
  padding-right: 2px;
}

#del-button:hover {
  color: white;
  border: 3px solid #f92f60;
  background-color: #f92f617e;
}

.sub-campaign {
  display: flex;
  justify-content: space-between;
  width: 60%;
  gap: 20px;
  align-self: center;
}

.module-container {
  display: flex;
  flex-direction: column;
}

.disabled-button {
  cursor: not-allowed;
  background-color: lightgray;

  &:hover {
    background-color: gray
  }
}
</style>